import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { DashboardData, DashboardPeriod } from '@/types/dashboard';

export function useDashboard(period: DashboardPeriod = '7d') {
  return useQuery({
    queryKey: ['dashboard', period],
    queryFn: async () => {
      const response = await api.get<DashboardData>(`/dashboard?period=${period}`);
      return response.data;
    },
    refetchInterval: 15_000,
  });
}
